// semantic-ui column number base
const base = 16;
const aside = base / 4;
const asideTablet = 7;
const content = (base / 4) * 3;
const contentTablet = 9;
const half = base / 2;
const menu = 2;
const menuContent = base - menu;

export {
  base,
  aside,
  asideTablet,
  content,
  contentTablet,
  half,
  menu,
  menuContent
};
